// Auto-generated index of all AI components

import Descriptive from "./AI_Components/Descriptive.jsx";
import Distribution from "./AI_Components/Distribution.jsx";
import Ex1_Data from "./AI_Components/Ex1_Data.jsx";
import Ex1_Intro from "./AI_Components/Ex1_Intro.jsx";
import Ex1_Model from "./AI_Components/Ex1_Model.jsx";
import Ex1_Training from "./AI_Components/Ex1_Training.jsx";
import Ex2_Data from "./AI_Components/Ex2_Data.jsx";
import Ex2_Intro from "./AI_Components/Ex2_Intro.jsx";
import Ex2_Model from "./AI_Components/Ex2_Model.jsx";
import Ex2_Training from "./AI_Components/Ex2_Training.jsx";
import Graph_Canvas from "./AI_Components/Graph_Canvas.jsx";
import Graph_Chart_js from "./AI_Components/Graph_Chart_js.jsx";
import Graph_D3_js from "./AI_Components/Graph_D3_js.jsx";
import Graph_Google from "./AI_Components/Graph_Google.jsx";
import Graph_Intro from "./AI_Components/Graph_Intro.jsx";
import Graph_Plotly_js from "./AI_Components/Graph_Plotly_js.jsx";
import History_of_AI from "./AI_Components/History_of_AI.jsx";
import History_of_Computing from "./AI_Components/History_of_Computing.jsx";
import History_of_Intelligence from "./AI_Components/History_of_Intelligence.jsx";
import History_of_Languages from "./AI_Components/History_of_Languages.jsx";
import History_of_Numbers from "./AI_Components/History_of_Numbers.jsx";
import History_of_Robots from "./AI_Components/History_of_Robots.jsx";
import Job_Replacements from "./AI_Components/Job_Replacements.jsx";
import Linear_Algebra from "./AI_Components/Linear_Algebra.jsx";
import Linear_Functions from "./AI_Components/Linear_Functions.jsx";
import ML_Brain_js from "./AI_Components/ML_Brain_js.jsx";
import ML_Clustering from "./AI_Components/ML_Clustering.jsx";
import ML_Data from "./AI_Components/ML_Data.jsx";
import ML_Deep_Learning from "./AI_Components/ML_Deep_Learning.jsx";
import ML_Examples from "./AI_Components/ML_Examples.jsx";
import ML_Intro from "./AI_Components/ML_Intro.jsx";
import ML_JavaScript from "./AI_Components/ML_JavaScript.jsx";
import ML_Languages from "./AI_Components/ML_Languages.jsx";
import ML_Learning from "./AI_Components/ML_Learning.jsx";
import ML_Linear_Graphs from "./AI_Components/ML_Linear_Graphs.jsx";
import ML_Perceptrons from "./AI_Components/ML_Perceptrons.jsx";
import ML_Recognition from "./AI_Components/ML_Recognition.jsx";
import ML_Regressions from "./AI_Components/ML_Regressions.jsx";
import ML_Scatter_Plots from "./AI_Components/ML_Scatter_Plots.jsx";
import ML_Terminology from "./AI_Components/ML_Terminology.jsx";
import ML_Testing from "./AI_Components/ML_Testing.jsx";
import ML_Training from "./AI_Components/ML_Training.jsx";
import ML_and_AI from "./AI_Components/ML_and_AI.jsx";
import Mathematics from "./AI_Components/Mathematics.jsx";
import Matrices from "./AI_Components/Matrices.jsx";
import Probability from "./AI_Components/Probability.jsx";
import Statistics from "./AI_Components/Statistics.jsx";
import TFJS_Models from "./AI_Components/TFJS_Models.jsx";
import TFJS_Operations from "./AI_Components/TFJS_Operations.jsx";
import TFJS_Tutorial from "./AI_Components/TFJS_Tutorial.jsx";
import TFJS_Visor from "./AI_Components/TFJS_Visor.jsx";
import Tensors from "./AI_Components/Tensors.jsx";
import Theory_of_Mind from "./AI_Components/Theory_of_Mind.jsx";
import Variability from "./AI_Components/Variability.jsx";
import Vectors from "./AI_Components/Vectors.jsx";

const AllAIComponents = {
  "<Descriptive />": Descriptive,
  "<Distribution />": Distribution,
  "<Ex1_Data />": Ex1_Data,
  "<Ex1_Intro />": Ex1_Intro,
  "<Ex1_Modelddd />": Ex1_Model,
  "<Ex1_Trainingddd />": Ex1_Training,
  "<Ex2_Dataddd />": Ex2_Data,
  "<Ex2_Introddd />": Ex2_Intro,
  "<Ex2_Modelddd />": Ex2_Model,
  "<Ex2_Trainingddd />": Ex2_Training,
  "<Graph_Canvasddd />": Graph_Canvas,
  "<Graph_Chart_jsddd />": Graph_Chart_js,
  "<Graph_D3_jsddd />": Graph_D3_js,
  "<Graph_Googleddd />": Graph_Google,
  "<Graph_Introddd />": Graph_Intro,
  "<Graph_Plotly_jsddd />": Graph_Plotly_js,
  "<History_of_AId />": History_of_AI,
  "<History_of_Computingd />": History_of_Computing,
  "<History_of_Intelligenced />": History_of_Intelligence,
  "<History_of_Languagesd />": History_of_Languages,
  "<History_of_Numbersd />": History_of_Numbers,
  "<History_of_Robotsd />": History_of_Robots,
  "<Job_Replacementsd />": Job_Replacements,
  "<Linear_Algebrad />": Linear_Algebra,
  "<Linear_Functionsd />": Linear_Functions,
  "<ML_Brain_jsd />": ML_Brain_js,
  "<ML_Clusteringd />": ML_Clustering,
  "<ML_Datad />": ML_Data,
  "<ML_Deep_Learningd />": ML_Deep_Learning,
  "<ML_Examplesd />": ML_Examples,
  "<ML_Intro />": ML_Intro,
  "<ML_JavaScript />": ML_JavaScript,
  "<ML_Languages />": ML_Languages,
  "<ML_Learning />": ML_Learning,
  "<ML_Linear_Graphs />": ML_Linear_Graphs,
  "<ML_Perceptrons />": ML_Perceptrons,
  "<ML_Recognition />": ML_Recognition,
  "<ML_Regressions />": ML_Regressions,
  "<ML_Scatter_Plots />": ML_Scatter_Plots,
  "<ML_Terminology />": ML_Terminology,
  "<ML_Testing />": ML_Testing,
  "<ML_Training />": ML_Training,
  "<ML_and_AI />": ML_and_AI,
  "<Mathematics />": Mathematics,
  "<Matrices />": Matrices,
  "<Probability />": Probability,
  "<Statistics />": Statistics,
  "<TFJS_Models />": TFJS_Models,
  "<TFJS_Operations />": TFJS_Operations,
  "<TFJS_Tutorial />": TFJS_Tutorial,
  "<TFJS_Visor />": TFJS_Visor,
  "<Tensors />": Tensors,
  "<Theory_of_Mind />": Theory_of_Mind,
  "<Variability />": Variability,
  "<Vectors />": Vectors,
};

export default AllAIComponents;
